<template>
  <Wrapper :has-warning="true">
    <template v-slot:status>
      {{ $t('shared.error.status') }}
    </template>
    <template v-slot:body>
      <Subtitle>{{ $t('shared.error.subtitle') }}</Subtitle>
      <Paragraph>
        {{ $t('shared.error.message') }}
      </Paragraph>
      <Paragraph
        v-html="
          $t('shared.correlation-id', {
            correlationId: `<b>${correlationId}</b>`,
          })
        "
      ></Paragraph>
    </template>
  </Wrapper>
</template>

<script>
import { getCorrelationId } from '../services/correlation';

import Paragraph from './paragraph.vue';
import Subtitle from './subtitle.vue';
import Wrapper from './wrapper.vue';

export default {
  name: 'Error',

  components: {
    Wrapper,
    Subtitle,
    Paragraph,
  },

  data() {
    return {
      correlationId: getCorrelationId()
    }
  },
};
</script>
